import React, { Fragment, useCallback, useState } from 'react';
import { Button, Card, Checkbox, Col, Form, Input, Modal, Row, Select } from 'antd';
import LoaderCsvFormMappingControl from './mapping-control';
import { GUTTER_MD, MARGIN_MD, MODAL_WIDTH_SM, SPAN_FULL, SPAN_HALF } from '../../../../styles/constants';
import {
    changeLoaderCsvForm,
    onHideLoaderCsvFormIgnoreConcurrentUploadConfirm,
    submitLoaderCsvForm,
    uploadLoaderCsvFormFile,
    onModalReviewDataflows,
    hideModalReviewDataflows,
    uploadDataflowBuilder
} from './actions';
import { translate } from 'react-i18next';
import { compose } from 'redux';
import FileInput from '../../../../components/file-input';
import { connect } from 'react-redux';
import LoaderCsvFormRowList from './row-list';
import { showLoaderCsvFormRowList } from './row-list/actions';
import { userMustNotInsertTid } from './utils';
import EmbargoInput from '../../../../components/embargo-input';
import Call from "../../../../hocs/call";
import { isIDValidWithHelp } from "../../../../utils/artefactValidators";
import "./style.css";
import CcPicker from '../ccPicker';
import EnhancedModal from '../../../../components/enhanced-modal';



const mapStateToProps = state => ({
    format: state.scenes.dataManager.loader.shared.format,
    mappingId: state.scenes.dataManager.loader.components.csvForm.shared.mappingId,
    mapping: state.scenes.dataManager.loader.components.csvForm.shared.mapping,
    mappingCube: state.scenes.dataManager.loader.components.csvForm.shared.mappingCube,
    tid: state.scenes.dataManager.loader.components.csvForm.shared.tid,
    importType: state.scenes.dataManager.loader.components.csvForm.local.importType,
    file: state.scenes.dataManager.loader.components.csvForm.local.file,
    separator: state.scenes.dataManager.loader.components.csvForm.shared.separator,
    delimiter: state.scenes.dataManager.loader.components.csvForm.shared.delimiter,
    hasHeader: state.scenes.dataManager.loader.components.csvForm.shared.hasHeader,
    hasDotStatFormat: state.scenes.dataManager.loader.components.csvForm.shared.hasDotStatFormat,
    fileServerPath: state.scenes.dataManager.loader.components.csvForm.shared.fileServerPath,
    csvServerPath: state.scenes.dataManager.loader.components.csvForm.shared.csvServerPath,
    embargo: state.scenes.dataManager.loader.components.csvForm.local.embargo,
    refreshProdDf: state.scenes.dataManager.loader.components.csvForm.local.refreshProdDf,
    checkFiltAttributes: state.scenes.dataManager.loader.components.csvForm.local.checkFiltAttributes,
    isIgnoreConcurrentUploadConfirmVisible: state.scenes.dataManager.loader.components.csvForm.local.isIgnoreConcurrentUploadConfirmVisible,
    cc: state.scenes.dataManager.loader.shared.cc,
    ccFileServerPath: state.scenes.dataManager.loader.shared.ccFileServerPath,
    deleteMode: state.scenes.dataManager.loader.components.csvForm.shared.deleteMode,
    hasMappingFieldExpressions: state.scenes.dataManager.loader.components.csvForm.shared.hasMappingFieldExpressions,
    showModalDataflowsReview: state.scenes.dataManager.loader.components.csvForm.shared.showModalDataflowsReview
});

const mapDispatchToProps = dispatch => ({
    onChange: fields => dispatch(changeLoaderCsvForm(fields)),
    onFileUpload: (file, mappingCubeId, format) => dispatch(uploadLoaderCsvFormFile(file, mappingCubeId, format)),
    onRowListShow: () => dispatch(showLoaderCsvFormRowList()),
    onSubmit: (separator, delimiter, hasHeader, importType, cubeId, mappingId, filePath, tid, cubeCode, idMappingSpecialTimePeriod, embargo, refreshProdDf, checkFiltAttributes, ignoreConcurrentUpload, cc, ccFileServerPath, deleteMode, hasMappingFieldExpressions) =>
        dispatch(submitLoaderCsvForm(separator, delimiter, hasHeader, importType, cubeId, mappingId, filePath, tid, cubeCode, idMappingSpecialTimePeriod, embargo, refreshProdDf, checkFiltAttributes, ignoreConcurrentUpload, cc, ccFileServerPath, null, deleteMode, hasMappingFieldExpressions)),
    onHideIgnoreConcurrentUploadConfirm: () => dispatch(onHideLoaderCsvFormIgnoreConcurrentUploadConfirm()),
    onShowModalDataflowsReview: () => dispatch(onModalReviewDataflows()),
    onHideModalDataflowsReview: () => dispatch(hideModalReviewDataflows()),
    uploadDataflowBuilder: (cubeId) => dispatch(uploadDataflowBuilder(cubeId))
});

const mapPropsToFields = ({
    mapping,
    tid,
    importType,
    file,
    separator,
    delimiter,
    hasHeader,
    hasDotStatFormat,
    embargo,
    refreshProdDf,
    checkFiltAttributes,
    deleteMode
}) => ({

    mappingId: Form.createFormField({ value: mapping !== null ? `[${mapping.Name}] ${mapping.Description || ''}` : null }),
    tid: Form.createFormField({ value: tid }),
    importType: Form.createFormField({ value: importType }),
    file: Form.createFormField({ value: file }),
    separator: Form.createFormField({ value: separator }),
    delimiter: Form.createFormField({ value: delimiter }),
    hasHeader: Form.createFormField({ value: hasHeader }),
    hasDotStatFormat: Form.createFormField({ value: hasDotStatFormat }),
    embargo: Form.createFormField({ value: embargo }),
    refreshProdDf: Form.createFormField({ value: refreshProdDf }),
    checkFiltAttributes: Form.createFormField({ value: checkFiltAttributes }),
    deleteMode: Form.createFormField({ value: deleteMode })
});

const onFieldsChange = (props, fields) => props.onChange(fields);

const LoaderCsvForm = ({
    t,
    format,
    form,
    mappingId,
    mapping,
    mappingCube,
    tid,
    importType,
    file,
    separator,
    hasHeader,
    hasDotStatFormat,
    delimiter,
    fileServerPath,
    csvServerPath,
    onFileUpload,
    onRowListShow,
    onSubmit,
    embargo,
    refreshProdDf,
    checkFiltAttributes,
    isIgnoreConcurrentUploadConfirmVisible,
    onHideIgnoreConcurrentUploadConfirm,
    cc,
    ccFileServerPath,
    deleteMode,
    hasMappingFieldExpressions,
    onShowModalDataflowsReview,
    onHideModalDataflowsReview,
    showModalDataflowsReview,
    uploadDataflowBuilder
}) => {

    const submit = useCallback((ignoreConcurrentUpload = false) => onSubmit(
        separator,
        !!delimiter ? delimiter : null,
        hasHeader,
        importType,
        mappingCube.IDCube,
        mappingId,
        csvServerPath,
        tid,
        mappingCube.Code,
        hasDotStatFormat ? mappingId : null,
        embargo ? embargo.enabled : false,
        refreshProdDf,
        checkFiltAttributes,
        ignoreConcurrentUpload,
        cc,
        ccFileServerPath,
        deleteMode,
        hasMappingFieldExpressions,
    ), [onSubmit, separator, delimiter, hasHeader, importType, mappingCube, mappingId, csvServerPath, tid,
        hasDotStatFormat, embargo, refreshProdDf, checkFiltAttributes, cc, ccFileServerPath, deleteMode, hasMappingFieldExpressions]);

    const [idCube, setIdCube] = useState(0)
    
    return (
        <Row type="flex" justify="center">
            <Col style={{ width: MODAL_WIDTH_SM }}>
                <Card type="inner">
                    <Form className="advanced-form">
                        <Row gutter={GUTTER_MD} style={{ marginBottom: MARGIN_MD }}>
                            <Col span={SPAN_FULL}>
                                <Form.Item className="form-item-required"
                                    label={t('scenes.dataManager.loader.csvForm.fields.mapping.label')}>
                                    <LoaderCsvFormMappingControl
                                        form={form}
                                        format={format}
                                        pluginId=""
                                        sequenceMappingEnabled={false}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                        {!userMustNotInsertTid(mapping, mappingCube) && (
                            <Row gutter={GUTTER_MD} style={{ marginBottom: MARGIN_MD }}>
                                <Col span={SPAN_FULL}>
                                    <Form.Item
                                        className="form-item-required"
                                        label={t('scenes.dataManager.loader.csvForm.fields.tid.label')}
                                        validateStatus={tid && isIDValidWithHelp(t, tid).help ? "warning" : null}
                                        help={tid && isIDValidWithHelp(t, tid).help}
                                    >
                                        {form.getFieldDecorator('tid', {
                                            getValueFromEvent: e => e.target.value.toUpperCase()
                                        })(<Input style={{ textTransform: "uppercase" }} />)}
                                    </Form.Item>
                                </Col>
                            </Row>
                        )}
                        <Row gutter={GUTTER_MD} style={{ marginBottom: MARGIN_MD }}>
                            <Col span={SPAN_FULL}>
                                <Form.Item
                                    className="form-item-required"
                                    label={t('scenes.dataManager.loader.csvForm.fields.importType.label')}
                                >
                                    {form.getFieldDecorator('importType')(
                                        <Select
                                            showSearch
                                            filterOption={(inputValue, { props }) =>
                                                props.title.toLowerCase().includes(inputValue.toLowerCase())
                                            }
                                            disabled={
                                                mappingId === null ||
                                                (
                                                    !userMustNotInsertTid(mapping, mappingCube)
                                                    &&
                                                    (!tid || tid.length === 0)
                                                )
                                            }
                                        >
                                            <Select.Option
                                                value="SeriesAndData"
                                                title={t('scenes.dataManager.loader.csvForm.fields.importType.option.SeriesAndData')}
                                            >
                                                {t('scenes.dataManager.loader.csvForm.fields.importType.option.SeriesAndData')}
                                            </Select.Option>
                                            <Select.Option
                                                value="Series"
                                                title={t('scenes.dataManager.loader.csvForm.fields.importType.option.Series')}
                                            >
                                                {t('scenes.dataManager.loader.csvForm.fields.importType.option.Series')}
                                            </Select.Option>
                                            <Select.Option
                                                value="Data"
                                                title={t('scenes.dataManager.loader.csvForm.fields.importType.option.Data')}
                                            >
                                                {t('scenes.dataManager.loader.csvForm.fields.importType.option.Data')}
                                            </Select.Option>
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={GUTTER_MD} style={{ marginBottom: MARGIN_MD }}>
                            <Col span={SPAN_FULL}>
                                <Form.Item className="form-item-required" label={t('data.csv.file.label')}>
                                    {form.getFieldDecorator('file')(
                                        <FileInput
                                            disabled={
                                                mappingId === null ||
                                                (
                                                    !userMustNotInsertTid(mapping, mappingCube)
                                                    &&
                                                    (!tid || tid.length === 0)
                                                )
                                            }
                                            accept={"." + format}
                                            isZipAllowed
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>
                        {format === 'csv' && (
                            <Fragment>
                                <Row gutter={GUTTER_MD} style={{ marginBottom: MARGIN_MD }}>
                                    <Col span={SPAN_HALF}>
                                        <Form.Item className="form-item-required"
                                            label={t('data.csv.separator.label')}>
                                            {form.getFieldDecorator('separator')(
                                                <Input
                                                    disabled={
                                                        mappingId === null ||
                                                        (
                                                            !userMustNotInsertTid(mapping, mappingCube)
                                                            &&
                                                            (!tid || tid.length === 0)
                                                        )
                                                    }
                                                    maxLength={1}
                                                />
                                            )}
                                        </Form.Item>
                                    </Col>
                                    <Col span={SPAN_HALF}>
                                        <Form.Item label={t('data.csv.delimiter.label')}>
                                            {form.getFieldDecorator('delimiter')(
                                                <Input
                                                    disabled={
                                                        mappingId === null ||
                                                        (
                                                            !userMustNotInsertTid(mapping, mappingCube)
                                                            &&
                                                            (!tid || tid.length === 0)
                                                        )
                                                    }
                                                    maxLength={1}
                                                />
                                            )}
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row gutter={GUTTER_MD} style={{ marginBottom: MARGIN_MD }}>
                                    <Col span={SPAN_HALF}>
                                        <Form.Item label={t('data.csv.hasHeader.label')}>
                                            {form.getFieldDecorator('hasHeader', { valuePropName: 'checked' })(
                                                <Checkbox
                                                    disabled={
                                                        mappingId === null ||
                                                        (
                                                            !userMustNotInsertTid(mapping, mappingCube)
                                                            &&
                                                            (!tid || tid.length === 0)
                                                        )
                                                    }
                                                />
                                            )}
                                        </Form.Item>
                                    </Col>
                                    <Col span={SPAN_HALF}>
                                        <Form.Item label={t('data.csv.hasDotStatFormat.label')}>
                                            {form.getFieldDecorator('hasDotStatFormat', { valuePropName: 'checked' })(
                                                <Checkbox
                                                    disabled={
                                                        mappingId === null ||
                                                        (
                                                            !userMustNotInsertTid(mapping, mappingCube)
                                                            &&
                                                            (!tid || tid.length === 0)
                                                        )
                                                    }
                                                />)}
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Fragment>
                        )}
                        <Row type="flex" justify="center" gutter={GUTTER_MD}
                            style={{ marginBottom: MARGIN_MD }}>
                            <Col>
                                <Form.Item>
                                    <Button
                                        onClick={() => onFileUpload(file, mappingCube.IDCube, format)}
                                        disabled={
                                            (
                                                !userMustNotInsertTid(mapping, mappingCube)
                                                &&
                                                (!tid || tid.length === 0)
                                            ) ||
                                            mappingCube === null ||
                                            file === null ||
                                            (format === 'csv' && (
                                                separator === null ||
                                                separator.length === 0 ||
                                                hasHeader === null
                                            ))
                                        }
                                        type="primary"
                                        icon="upload"
                                    >
                                        {t('data.csv.uploadButton.label')}
                                    </Button>
                                </Form.Item>
                            </Col>
                            <Col>
                                <Form.Item>
                                    <Button onClick={onRowListShow} disabled={csvServerPath === null} icon="table">
                                        {t('data.csv.tableShowButton.label')}
                                    </Button>
                                    <LoaderCsvFormRowList />
                                </Form.Item>
                            </Col>
                        </Row>
                        <CcPicker form={form} />
                        <Row type="flex" style={{ marginBottom: MARGIN_MD }}>
                            <Col span={SPAN_FULL}>
                                <Form.Item>
                                    {form.getFieldDecorator('embargo')(
                                        <EmbargoInput disabled={csvServerPath === null} />
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row type="flex" align='middle' style={{ marginBottom: MARGIN_MD }}>
                            <Col span={9}>
                                <Form.Item label={t('scenes.dataManager.loader.csvForm.refreshProdDf.label')}>
                                    {form.getFieldDecorator('refreshProdDf', { valuePropName: 'checked' })(
                                        <Checkbox disabled={fileServerPath === null} />)}
                                </Form.Item>
                            </Col>
                            <Col span={8} style={{ display: 'flex', justifyContent: 'center' }}>
                                <Form.Item
                                    label={t('scenes.dataManager.loader.csvForm.checkFiltAttributes.label')}>
                                    {form.getFieldDecorator('checkFiltAttributes', { valuePropName: 'checked' })(
                                        <Checkbox disabled={fileServerPath === null} />)}
                                </Form.Item>
                            </Col>
                            <Col span={7} style={{ display: 'flex', justifyContent: 'flex-end' }} >
                                <Form.Item
                                    label={t('scenes.dataManager.loader.csvForm.deleteMode.label')}>
                                    {form.getFieldDecorator('deleteMode', { valuePropName: 'checked' })(
                                        <Checkbox disabled={fileServerPath === null} />)}
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row type="flex" justify="center">
                            <Col>
                                <Form.Item>
                                    <Call
                                        cb={() => Modal.confirm({
                                            title: t('scenes.dataManager.loader.confirms.ignoreConcurrentUpload.title'),
                                            content: t('scenes.dataManager.loader.confirms.ignoreConcurrentUpload.content'),
                                            onOk() {
                                                submit(true);
                                                onHideIgnoreConcurrentUploadConfirm();
                                            },
                                            onCancel() {
                                                onHideIgnoreConcurrentUploadConfirm();
                                            },
                                            cancelText: t('commons.buttons.cancel.title')
                                        })}
                                        disabled={!isIgnoreConcurrentUploadConfirmVisible}
                                    >
                                        <Button
                                            onClick={() => {
                                                setIdCube(mappingCube.IDCube)
                                                Modal.confirm({
                                                title: t('scenes.dataManager.loader.confirms.submit.title'),
                                                onOk() {
                                                    submit()
                                                    
                                                },
                                                cancelText: t('commons.buttons.cancel.title')
                                            })}
                                        }
                                            disabled={
                                                mappingId === null || mappingCube === null || importType === null ||
                                                (
                                                    !userMustNotInsertTid(mapping, mappingCube)
                                                    &&
                                                    (!tid || tid.length === 0)
                                                )
                                                || (format === 'csv' && (separator === null || separator.length === 0 || hasHeader === null))
                                                || csvServerPath === null
                                            }
                                            type="primary"
                                            icon="check"
                                        >
                                            {t('scenes.dataManager.loader.csvForm.submitButton.label')}
                                        </Button>
                                        
                                    </Call>
                                    <Fragment>
                                        <EnhancedModal
                                            visible={showModalDataflowsReview}
                                            title={t("scenes.dataManager.loader.modals.dataflowReview.title")}
                                            onCancel={onHideModalDataflowsReview}
                                            footer={
                                                <Fragment>
                                                    <Button onClick={onHideModalDataflowsReview}>
                                                        {t('commons.buttons.cancel.title')}
                                                    </Button>
                                                    <Button
                                                        type='primary'
                                                        onClick={() => uploadDataflowBuilder(idCube)}
                                                    >
                                                        {t('commons.buttons.confirm.title')}
                                                    </Button>
                                                </Fragment>
                                            }
                                            width={MODAL_WIDTH_SM}
                                        >
                                            <Row>
                                                {t("scenes.dataManager.loader.modals.dataflowReview.content")}
                                            </Row>
                                        </EnhancedModal>
                                    </Fragment>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </Card>
            </Col>
        </Row>
    );
}


export default compose(
    translate(),
    connect(mapStateToProps, mapDispatchToProps),
    Form.create({
        mapPropsToFields,
        onFieldsChange
    })
)(LoaderCsvForm);
